import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import { useSpotlightConventions } from "@seabrookstudios/pitch2table";
import CardMedia from "@mui/material/CardMedia";
import { formatConventionDate, formatFullDate, formatLocation } from "@seabrookstudios/pitch2table-core";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import { Path } from "../Path";

const PitchEventCard = ({ convention }) => {
  if (convention.type !== "PitchEvent") {
    return null;
  }

  return (
    <Card>
      <CardMedia image={convention.logoUrl} sx={{ height: 200 }} />
      <CardHeader title={convention.name} />
      <CardContent>
        <Typography paragraph>{convention.description}</Typography>
        <ListItemText
          primary="When"
          secondary={`${formatConventionDate(convention)} • ${formatLocation(convention)}`}
        />
        <ListItemText primary="Submissions Close" secondary={`${formatFullDate(convention.submissionDate)}`} />
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          color="primary"
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<OpenInNewIcon />}
          component={Link}
          to={convention.website}
        >
          Learn More
        </Button>
        <Button variant="contained" color="primary" component={Link} to={Path.events().event(convention.id)}>
          VIEW EVENT
        </Button>
      </CardActions>
    </Card>
  );
};

export const AnnouncementCard = () => {
  const { data: conventions = [] } = useSpotlightConventions();

  return conventions.map((convention) => <PitchEventCard key={convention.id} convention={convention} />);
};
